import { ChevronRight, LockOutlined, WarningAmber } from "@mui/icons-material";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import React from "react";
import { Profile } from "../../../../@types/profile";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  documentNumberFormatter,
  maskPhone,
} from "../../../../services/UtilsService";

interface ItemProps {
  children: React.ReactNode;
}

const Item: React.FC<ItemProps> = ({ children }) => {
  return (
    <Box display={"flex"} justifyContent={"space-between"} padding={2}>
      {children}
    </Box>
  );
};

const PersonalInformation: React.FC = () => {
  const profile = useAppSelector<Profile | undefined>(
    (state) => state.profileSlice.profile
  );

  if (!profile) return <></>;

  return (
    <Box>
      <Typography color={"typography.secondary"} variant="h3" paddingY={2}>
        Dados pessoais
      </Typography>

      <Box
        display={"flex-column"}
        gap={2}
        sx={{
          border: "1px solid grey",
          borderRadius: "8px",
          borderColor: "#E9EBF0",
        }}
      >
        <Item>
          <Box>
            <Typography variant="body1">Nome</Typography>
            <Typography variant="caption" color={"typography.secondary"}>
              {profile.person.name}
            </Typography>
          </Box>

          <Box>
            <IconButton
              href={"profile/edit/name"}
              style={{
                color: "typography.disabled",
              }}
            >
              <ChevronRight />
            </IconButton>
          </Box>
        </Item>
        <Divider />
        <Item>
          <Box>
            <Typography variant="body1">CPF</Typography>
            <Typography variant="caption" color={"typography.secondary"}>
              {documentNumberFormatter(profile.person.documentNumber)}
            </Typography>
          </Box>

          <IconButton disabled>
            <LockOutlined />
          </IconButton>
        </Item>
        <Divider />
        <Item>
          <Box>
            <Typography variant="body1">Celular</Typography>
            <Typography variant="caption" color={"typography.secondary"}>
              {maskPhone(profile.person.mobilePhone)}
            </Typography>
          </Box>

          <Box>
            <IconButton
              href="profile/edit/phone"
              style={{
                color: "typography.disabled",
              }}
            >
              <ChevronRight />
            </IconButton>
          </Box>
        </Item>
        <Divider />
        <Item>
          <Box display={"flex"} gap={2}>
            {!profile.email_verified && (
              <Box display={"flex"} alignItems={"center"}>
                <WarningAmber color="warning" fontSize="large" />
              </Box>
            )}
            <Box>
              <Typography variant="body1">Email</Typography>
              <Box display={"flex"} gap={1}>
                <Typography variant="caption" color={"typography.secondary"}>
                  {profile.person.email}
                </Typography>
                {!profile.email_verified && (
                  <Typography variant="caption" color="warning.main">
                    Não verificado
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>

          <Box>
            <IconButton
              href="profile/edit/email"
              style={{
                color: "typography.disabled",
              }}
            >
              <ChevronRight />
            </IconButton>
          </Box>
        </Item>
      </Box>
    </Box>
  );
};

export default PersonalInformation;
